import BannerNewUser from './styled';

export default BannerNewUser;
